import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import { useParams, withRouter } from 'react-router';
import OpcDaWriterLogEditService from '../service/OpcDaWriterLogEditService';
import UserGroupService from 'app/admin/userGroup/service/UserGroupService';

const config = data => {
	return {
		key: 'opcDaWriterLogEditForm',
		topic: 'opcDaWriterLog',
		service: OpcDaWriterLogEditService,
		fields: initData => {
			const fields = [
				{
					key: 'name',
					component: EditFormTextField,
					required: true,
					readOnly: data.id !== 'new'
				},
				{
					key: 'userGroup',
					component: EditFormSelectField,
					// multiple: true,
					items: () => UserGroupService.getListSelection()
				},
				{
					key: 'tableName',
					component: EditFormTextField
				},
				{
					key: 'description',
					component: EditFormTextField,
					multiline: true
				}
			];

			return fields;
		}
	};
};

function OpcDaWriterLogEditForm() {
	const { id } = useParams();
	const myConfig = config({ id });
	return (
		<EditFormPage config={myConfig} />
	);
}

export default withRouter(OpcDaWriterLogEditForm);